import React, { useCallback, useContext } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./kyb.css";
import { ProfileContext } from "../../../context/ProfileProvider";
import { useKybStatusRouting } from "./useKybStatus";
import { useKybVerifyAction } from "./kybCtaHelpers";
import { pickKybApplicationId, pickKybBusinessName } from "./kybDisplayFields";

export default function KYBFailed() {
  const profileCtx = useContext(ProfileContext) || {};
  const handleUserDetails = profileCtx.handleUserDetails;

  const {
    kybStatusRes,
    canonicalStatus,
    diditStatus,
    sessionPayload,
    hasResponse,
    loadKybStatus,
  } = useKybStatusRouting();

  const onFlowEnd = useCallback(() => {
    void loadKybStatus();
    handleUserDetails?.();
  }, [loadKybStatus, handleUserDetails]);

  const { busy, cta, startVerify } = useKybVerifyAction({
    kybStatusRes,
    canonicalStatus,
    diditStatus,
    onFlowEnd,
  });

  const businessName = pickKybBusinessName(sessionPayload);
  const applicationId = pickKybApplicationId(sessionPayload);
  const reason =
    sessionPayload?.reason
    || sessionPayload?.reject_reason
    || sessionPayload?.rejection_reason
    || "";
  const reasonList = Array.isArray(sessionPayload?.rejectionReasons)
    ? sessionPayload.rejectionReasons
    : (reason ? [reason] : []);

  return (
    <div className="dashboard_right">
      <Helmet>
        <meta
          httpEquiv="Permissions-Policy"
          content="camera=*, microphone=*, display-capture=*, fullscreen=*, publickey-credentials-get=*"
        />
      </Helmet>
      <div className="kyc-page kyb_verification_page">
        <div className="kyb_page_header">
          <h1>KYB Verification</h1>
        </div>

        <div className="kyb_status_container failled_section">
          <div className="kyb_status_icon_wrap failledicon">
            <img src="/images/kyb-verification-img/kyb_failled_icon.png" alt="Failed" />
          </div>

          <h2 className="kyb_status_title">
            KYB Verification <span className="failed">Failed</span>
          </h2>

          <p className="kyb_status_desc">
            We&apos;re unable to verify your business at this time.<br />
            Please review the reason below and resubmit your application.
          </p>

          {cta.show ? (
            <div className="kyb_status_actions">
              <button
                type="button"
                className="kyb-try-again-btn"
                onClick={() => void startVerify({ forceNew: true })}
                disabled={busy || !hasResponse}
                aria-busy={busy}
              >
                {busy ? "Starting…" : (cta.label || "Try Again")}
              </button>
              <Link to="/user_profile/my_tickets" className="kyb_help_btn kyb_help_btn_outline">
                Need Help?
              </Link>
            </div>
          ) : null}

          <div className="kyb_info_card">

            <div className="kyb_info_item">
              <div className="kyb_info_icon">
                <img src="/images/kyb-verification-img/kyb_fialed_icon.svg" alt="Icon" />
              </div>
              <div className="kyb_info_text">
                <div className="kyb_info_label">Business Name</div>
                <div className="kyb_info_value">{businessName}</div>
              </div>
            </div>

            <div className="kyb_info_item">
              <div className="kyb_info_icon">
                <img src="/images/kyb-verification-img/kyb_fialed_icon3.svg" alt="Icon" />
              </div>
              <div className="kyb_info_text">
                <div className="kyb_info_label">Application ID</div>
                <div className="kyb_info_value">{applicationId}</div>
              </div>
            </div>

            <div className="kyb_info_item">
              <div className="kyb_info_icon">
                <img src="/images/kyb-verification-img/kyb_fialed_icon4.svg" alt="Icon" />
              </div>
              <div className="kyb_info_text">
                <div className="kyb_info_label">Verification Status</div>
                <div className="kyb_info_value failed">
                  <i className="ri-close-line"></i> Failed
                </div>
              </div>
            </div>

            <div className="kyb_info_item">
              <div className="kyb_info_icon">
                <img src="/images/kyb-verification-img/kyb_fialed_icon5.svg" alt="Icon" />
              </div>
              <div className="kyb_info_text">
                <div className="kyb_info_label">Verified By</div>
                <div className="kyb_info_value">Arab Global Crypto Exchange</div>
              </div>
            </div>

            <div className="kyb_info_item">
              <div className="kyb_info_icon">
                <img src="/images/kyb-verification-img/kyb_fialed_icon6.svg" alt="Icon" />
              </div>
              <div className="kyb_info_text">
                <div className="kyb_info_label">Verification Method</div>
                <div className="kyb_info_value">Business Verification (KYB)</div>
              </div>
            </div>

          </div>

          <div className="kyb_error_box">
            <div className="kyb_error_header">
              <img src="/images/kyb-verification-img/failure_icon.svg" alt="Icon" /> Reason for Failure
            </div>
            <div className="kyb_error_text">
              We were unable to verify your business due to the following reason(s):
            </div>
            <ul className="kyb_error_list">
              {reasonList.length ? (
                reasonList.map((item, idx) => (
                  <li key={`kyb-reason-${idx}`}>{String(item)}</li>
                ))
              ) : (
                <li>Verification was declined. Please resubmit with correct documents.</li>
              )}
            </ul>
            <div className="kyb_error_footer">
              Please review the details and resubmit with the correct<br />
              information.
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
